import { createApp } from '@/services/createApp';
createApp("car", {"productVersion":"v3","isLeadgen":false,"skeletonLoader":false});